var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof TreatmentsUI !== "undefined") return resolve();
	__webpack_require__.l("https://unison-eus-d5.unison.fmcgds-np.com/treatments-mfe/remoteEntry.js?v=461589", (event) => {
		if(typeof TreatmentsUI !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "TreatmentsUI");
}).then(() => (TreatmentsUI));